import {SachetAction} from '../model/sachet-action.model';
import {SimpleUserInfo} from '../model/simple-user-info.model';
import {ActionTypeEnum} from '../constants/action-type.enum';
import {SachetStock} from '../model/sachet-stock.model';
import {User} from '../model/user.model';
import {SachetTypeEnum} from '../constants/sachet-type.enum';
import {TokenGeneratorUtil} from '../util/token-generator.util';

export class SachetActionHelper {

    generateSachetBatch(action: SachetAction, user: User, date: Date): SachetAction {

        action.token = TokenGeneratorUtil.generateToken();

        const userInfo: SimpleUserInfo = new SimpleUserInfo(user.uid, user.email, user.firstName + ' ' + user.lastName);

        action.date = date;

        action.dateTimestamp = date.getTime();

        action.actionType = ActionTypeEnum.STOCK_ADDICTION;

        action.patientType = '-';

        action.malnutritionType = '-';

        action.user = userInfo;

        action.organization = user.organizationName;
        action.organizationId = user.organizationModel.id;

        return action;
    }

    generateSachetDelivered(action: SachetAction, user: User, date: Date): SachetAction {

        action.token = TokenGeneratorUtil.generateToken();

        const userInfo: SimpleUserInfo = new SimpleUserInfo(user.uid, user.email, user.firstName + ' ' + user.lastName);

        action.date = date;

        action.dateTimestamp = date.getTime();

        action.actionType = ActionTypeEnum.DELIVERIES_SACHETS;

        action.patientType = '-';

        action.malnutritionType = '-';

        action.user = userInfo;

        action.organization = user.organizationName;
        action.organizationId = user.organizationModel.id;

        return action;
    }

    editSachetBatch(action: SachetAction, user: User, date: Date): SachetAction {

        action.token = TokenGeneratorUtil.generateToken();

        const userInfo: SimpleUserInfo = new SimpleUserInfo(user.uid, user.email, user.firstName + ' ' + user.lastName);

        action.date = date;

        action.dateTimestamp = date.getTime();

        action.actionType = ActionTypeEnum.EDITED_STOCK;

        action.patientType = '-';

        action.malnutritionType = '-';

        action.user = userInfo;

        action.organization = user.organizationName;
        action.organizationId = user.organizationModel.id;

        return action;
    }

    updateStock(action: SachetAction, user: User, add: boolean): SachetStock {
        const sachetsStock = new SachetStock();
        sachetsStock.code = `sachets-count-${user.organizationModel.id}`;
        sachetsStock.lastUpdate = action.date;
        sachetsStock.organization = user.organizationName;
        sachetsStock.organizationId = user.organizationModel.id;
        if (SachetTypeEnum.RED === action.sachetType) {
            sachetsStock.redCount = add ? action.counter : action.counter * -1;
            sachetsStock.yellowCount = 0;
            sachetsStock.color = 'red';
        } else if (SachetTypeEnum.YELLOW === action.sachetType) {
            sachetsStock.yellowCount = add ? action.counter : action.counter * -1;
            sachetsStock.redCount = 0;
            sachetsStock.color = 'yellow';
        }

        return sachetsStock;
    }


}
